<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
    <!-- <div 
      class="draggable-player"
      :style="{ top: playerPosition.top + 'px', left: playerPosition.left + 'px' }"
      @mousedown="startDrag($event, 'player')"
    >
      <player></player>
    </div>
    <div 
      class="draggable-record"
      :style="{ top: recorderPosition.top + 'px', left: recorderPosition.left + 'px' }"
      @mousedown="startDrag($event, 'recorder')"
    >
      <record></record> -->
    <!-- </div> -->
  </div>
</template>
<script>
import Head from "../src/components/HeadTitle.vue";
import player from "../src/views/Recorder/GlobalPlayerControl";
import record from "../src/views/Recorder/GlobalRecorderControl";

export default {
  name: "APP",
  components: {
    Head, // Global registration of the Head component
    player,
    record,
  },
  data() {
    return {
      playerPosition: {
        top: window.innerHeight - 500, // 从窗口底部向上300像素
        left: window.innerWidth - 250  // 从窗口右侧向左250像素
      },
      recorderPosition: {
        top: window.innerHeight - 100, // 从窗口底部向上100像素
        left: window.innerWidth - 100  // 从窗口右侧向左100像素
      },
      dragging: null,
      startX: 0,
      startY: 0,
      initialTop: 0,
      initialLeft: 0
    };
  },
  mounted() {
    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('mouseup', this.stopDrag);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
  },
  methods: {
    startDrag(event, element) {
      this.dragging = element;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.initialTop = this[element + 'Position'].top;
      this.initialLeft = this[element + 'Position'].left;
      event.preventDefault();
    },
    onDrag(event) {
      if (!this.dragging) return;
      
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      
      // 更新位置
      this[this.dragging + 'Position'].top = this.initialTop + deltaY;
      this[this.dragging + 'Position'].left = this.initialLeft + deltaX;
      
      // 限制在屏幕范围内
      if (this[this.dragging + 'Position'].top < 0) {
        this[this.dragging + 'Position'].top = 0;
      }
      if (this[this.dragging + 'Position'].left < 0) {
        this[this.dragging + 'Position'].left = 0;
      }
      if (this[this.dragging + 'Position'].top > window.innerHeight - 50) {
        this[this.dragging + 'Position'].top = window.innerHeight - 50;
      }
      if (this[this.dragging + 'Position'].left > window.innerWidth - 50) {
        this[this.dragging + 'Position'].left = window.innerWidth - 50;
      }
    },
    stopDrag() {
      this.dragging = null;
    }
  }
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
  /* margin: -8px -8px auto; */
  height: 100vh;
  /* overflow: auto; */
  /* overflow: auto;
  display: flex;
  flex-direction: column; */
  position: relative;
}
html, body {
  margin: 0; 
  padding: 0;
  height: 100%;
  font-family: sans-serif;

  /* overflow: hidden; */
}
.router-view {
  flex: 1; /* This will make the router view fill the available vertical space */
}

.draggable-player {
  position: fixed;
  z-index: 9999;
  cursor: move;
  user-select: none; /* 防止文本被选中 */
  -webkit-user-select: none; /* Safari兼容 */
  -moz-user-select: none; /* Firefox兼容 */
  -ms-user-select: none; /* IE兼容 */
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 100px;
  min-height: 50px;
  padding: 8px;
}


.draggable-record {
  position: fixed;
  z-index: 9999;
  cursor: move;
  user-select: none; /* 防止文本被选中 */
  -webkit-user-select: none; /* Safari兼容 */
  -moz-user-select: none; /* Firefox兼容 */
  -ms-user-select: none; /* IE兼容 */
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 50%; /* 设置为圆形 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 60px; /* 设置固定宽度 */
  height: 60px; /* 设置固定高度 */
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; /* 防止内部元素超出边界 */
}

.draggable-player *, .draggable-record * {
  pointer-events: auto; /* 确保内部元素的事件正常工作 */
}

/* html,body {
  height: 100%;
}
#app{
  height:100%;
} */
</style>